(() => {
  const scene = document.querySelector('[data-he-halloween]');
  if (!scene) return;
  const smoke = document.querySelector('[data-he-halloween-smoke]');

  const seconds = Number.parseFloat(scene.dataset.duration || '5');
  const duration = Math.min(8, Math.max(3, Number.isFinite(seconds) ? seconds : 5)) * 1000;
  let timer;

  const play = () => {
    window.clearTimeout(timer);
    scene.hidden = false;
    scene.classList.remove('is-leaving');

    window.requestAnimationFrame(() => {
      scene.classList.add('is-visible');
    });

    timer = window.setTimeout(() => {
      scene.classList.add('is-leaving');
      scene.classList.remove('is-visible');
    }, duration);
  };

  scene.addEventListener('transitionend', (event) => {
    if (event.target === scene && scene.classList.contains('is-leaving')) {
      scene.hidden = true;
    }
  });

  play();

  if (smoke) {
    smoke.classList.add('is-arriving');
    window.setTimeout(() => smoke.classList.remove('is-arriving'), 1200);

    document.addEventListener('click', (event) => {
      if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
        return;
      }

      const target = event.target instanceof Element ? event.target : null;
      const link = target?.closest('a[href]');
      if (!link || link.target === '_blank' || link.hasAttribute('download')) return;

      const destination = new URL(link.href, window.location.href);
      const current = new URL(window.location.href);
      const isSamePageHash = destination.pathname === current.pathname && destination.search === current.search && destination.hash;
      const skipsTransition = destination.origin !== current.origin || isSamePageHash || destination.pathname.includes('/checkout');
      if (skipsTransition) return;

      event.preventDefault();
      smoke.classList.remove('is-arriving');
      smoke.classList.add('is-leaving');
      window.setTimeout(() => window.location.assign(destination.href), 420);
    });
  }

  // Shopify's editor can redraw the layout without a full page reload.
  document.addEventListener('shopify:section:load', play);
  window.addEventListener('pageshow', (event) => {
    if (event.persisted) {
      smoke?.classList.remove('is-leaving');
      play();
    }
  });
})();
